var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"custom-chip",style:({ 
		color: _vm.getTextColor(_vm.params.data.modalidade),
		backgroundColor: '#757575'
	}),attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.params.data.modalidade ? _vm.params.data.modalidade : 'Sem Modalidade')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }